<div fxFlexFill fxLayout="column" fxLayoutAlign="start stretch">
    <div
        fxFlex
        fxLayout="row"
        fxLayoutAlign="space-around center"
        fxLayoutGap="30px"
        fxLayout.lt-md="column"
        fxLayoutAlign.lt-md="start center"
    >
        <div fxShow fxHide.lt-md fxFlex.gt-md="60" fxFlex.md="50">
            <!--<div fxLayout="row" fxLayoutAlign="center center" class="margin-bottom">
                <div class="inner welcomebox mat-elevation-z10" [class.lt-md]="SmallDisplay" [class.gt-sm]="!SmallDisplay">
                    <mat-toolbar color="warn"> <span>Planned System Outage</span> </mat-toolbar>
                    <div>
                        There will be a brief system outage for the IRIS System on <strong>Friday, February 7, 2020</strong> between
                        <strong>9:00AM and 10:00AM</strong>. During this time, access to the system may be limited. This outage is
                        intended to allow for new feature changes and enhancements to be added to the system. We apologize for the
                        inconvenience and will work to minimize the outage time. Thank you.
                    </div>
                </div>
            </div>-->
            <div fxLayout="row" fxLayoutAlign="center center">
                <div class="inner welcomebox mat-elevation-z10" [class.lt-md]="SmallDisplay" [class.gt-sm]="!SmallDisplay">
                    <mat-toolbar color="primary"> <span>Welcome to IRIS!</span> </mat-toolbar>
                    <div>
                        The Internal Request for Information System (IRIS) is a product of Polk County Public Schools and is intended
                        to serve as a portal for the creation, processing, and retrieving of information for requests made by multiple
                        entities. Please log in to the system using your standard PCPS login credentials (first.last as your username,
                        and your county email password as your account password).
                    </div>
                </div>
            </div>
        </div>

        <div fxFlex fxLayout="column" fxLayoutAlign="center center" fxLayoutAlign.lt-md="start center">
            <div class="topbox loginform" [class.lt-md]="SmallDisplay" [class.gt-sm]="!SmallDisplay">
                <!-- <div class="inner mat-elevation-z10"> -->
                <form class="inner mat-elevation-z10" #f="ngForm" (ngSubmit)="onSubmit(f.value)" novalidate>
                    <div fxFlexFill fxLayout="column" fxLayoutAlign="space-between stretch">
                        <div fxLayout="column" fxLayoutAlign="start stretch">
                            <mat-toolbar color="accent">
                                <span appMobileTap (doubleTap)="ShowImpersonation($event)">Login</span>
                            </mat-toolbar>
                            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                                <mat-form-field appearance="outline">
                                    <input matInput placeholder="Username" name="username" id="username" ngModel required autofocus />
                                    <mat-hint align="start">District staff: Please use firstname.lastname only</mat-hint>
                                </mat-form-field>
                                <mat-icon>person</mat-icon>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                                <mat-form-field appearance="outline">
                                    <input matInput placeholder="Password" type="password" name="password" id="password" ngModel />
                                </mat-form-field>
                                <mat-icon appMobileTap (doubleTap)="ShowImpersonation($event)">lock_outline</mat-icon>
                            </div>
                            <div *ngIf="ShowImpersonationBox">
                                <mat-checkbox matInput name="training" ngModel>Training Mode</mat-checkbox>
                            </div>
                            <mat-form-field *ngIf="ShowImpersonationBox" appearance="outline">
                                <input
                                    matInput
                                    placeholder="Impersonated Account/UserID"
                                    type="password"
                                    name="impersonated"
                                    id="impersonated"
                                    ngModel
                                />
                                <mat-icon matSuffix>account_circle</mat-icon>
                            </mat-form-field>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutWrap>
                            <div>
                                <button mat-raised-button type="submit" color="accent" [disabled]="f.invalid || LoginInProgress">
                                    Login
                                </button>
                            </div>
                            <div>
                                <a mat-button color="warn" href="https://password.mypolkschools.net/?from=IRIS">Need Password Help?</a>
                            </div>
                            <div><button mat-raised-button color="accent" type="button" (click)="f.reset()">Reset</button></div>
                        </div>
                    </div>
                </form>
                <!-- </div> -->
            </div>
            <div class="inner welcomebox mat-elevation-z10" [class.lt-md]="SmallDisplay" [class.gt-sm]="!SmallDisplay">
                <mat-toolbar color="primary"> <span>District Staff</span> </mat-toolbar>
                <div>
                    <p>
                        Please use your Polk County Public Schools (PCPS) credentials to access the system. You do <em>not</em> need to
                        provide the <em>@polk-fl.net</em> portion of your email address as part of your username.
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>
